export default "https://statics.cloudfastin.top/static/v1.27.38.2/store/images/new_codedisplay_2_right.png?e23cf77e84282e855184545228fc603c";